import ScheduleCalendar from './ScheduleCalendar';
import ScheduleSidebar from './ScheduleSidebar';

import classes from './schedule.module.css';

const SchedulePortal = () => {
  return (
    <div className={classes.portalContainer}>
      <ScheduleSidebar />
      <ScheduleCalendar />
    </div>
  );
};

export default SchedulePortal;
